import { useEffect, useState } from 'react';
import { Platform, View } from 'react-native';
import Modal from 'react-native-modal';
import { createStyleSheet, useStyles } from 'react-native-unistyles';
import WebView from 'react-native-webview';

import {
  NavigationButton,
  NavigationButtonTypes,
} from '@/components/navigation-button';
import { Text } from '@/ui';

interface WhyGloveboxPinModalProps {
  visible?: boolean;
  onClose: () => void;
  style?: any;
}

export function WhyGloveboxPinModal({
  visible = false,
  onClose,
  style,
}: WhyGloveboxPinModalProps) {
  const { styles, theme } = useStyles(stylesheet);
  const [showModal, setShowModal] = useState(visible);

  useEffect(() => {
    setShowModal(visible);
  }, [visible]);

  return (
    <Modal
      animationIn="slideInUp"
      animationInTiming={300}
      animationOut="slideOutDown"
      animationOutTiming={300}
      isVisible={showModal}
      hasBackdrop
      style={{
        ...styles.container,
        ...style,
      }}
      onBackdropPress={() => {
        setShowModal(false);
        onClose?.();
      }}
    >
      <View style={styles.containerView}>
        <View
          style={{
            flexDirection: 'row',
            paddingTop: 16,
            paddingLeft: 16,
          }}
        >
          <View style={{ width: '90%' }}>
            <Text type="title2">Why Do You Need to Set a Glovebox Pin?</Text>
          </View>

          <NavigationButton
            type={NavigationButtonTypes.cancel}
            onPress={() => {
              setShowModal(false);
              onClose?.();
            }}
            style={{
              position: 'absolute',
              right: 16,
              top: 16,
            }}
          />
        </View>

        <View style={{ padding: 16, gap: 24 }}>
          <Text
            type="bodyRegular"
            style={{ color: theme.colors.text.secondary }}
          >
            Renters unlock your car via Bluetooth. If their phone dies or
            connection fails, this PIN lets them access the backup keycard
            stored in your glovebox. Bluetooth handles daily use, this is just a
            safety net
          </Text>

          <View style={{ gap: 8 }}>
            <Text type="bodyBold">
              Set a unique Glovebox PIN for every car you list on Eon
            </Text>

            <Text
              type="bodyRegular"
              style={{ color: theme.colors.text.secondary }}
            >
              You can do this from the car settings page, or contact support if
              you need help
            </Text>
          </View>

          <View style={{ gap: 8 }}>
            <Text type="bodyBold">You're Covered</Text>

            <Text
              type="bodyRegular"
              style={{ color: theme.colors.text.secondary }}
            >
              If the keycard is lost or stolen, you're fully covered. no cost to
              you for replacement
            </Text>
          </View>

          <View style={{ gap: 8 }}>
            <Text type="bodyBold">How to set a Glovebox PIN</Text>

            <Text
              type="bodyRegular"
              style={{ color: theme.colors.text.secondary }}
            >
              If the keycard is lost or stolen, you're fully covered. no cost to
              you for replacement
            </Text>
          </View>

          <View
            style={{
              width: '100%',
              height: 160,
            }}
          >
            {Platform.OS === 'web' ? (
              <iframe
                src={
                  'https://www.youtube.com/embed/8e6ZL083cu0?si=PiN8nnCApczuqSrG'
                }
                style={{
                  width: '100%',
                  height: '100%',
                  border: 'none',
                  borderRadius: 16,
                }}
                allowFullScreen
              />
            ) : (
              <View
                style={{ flexGrow: 1, borderRadius: 16, overflow: 'hidden' }}
              >
                <WebView
                  javaScriptEnabled
                  domStorageEnabled
                  source={{
                    uri: 'https://www.youtube.com/watch?v=8e6ZL083cu0',
                  }}
                  style={{
                    borderRadius: 16,
                  }}
                />
              </View>
            )}
          </View>
        </View>
      </View>
    </Modal>
  );
}

const stylesheet = createStyleSheet((theme) => ({
  container: {
    margin: 0,
    marginTop: 48,
    paddingBottom: {
      xs: 16,
      md: 0,
    },
    alignSelf: 'center',
    maxWidth: {
      xs: '100%',
      sm: 600,
    },
    width: {
      xs: '100%',
    },
  },
  containerView: {
    backgroundColor: theme.colors.background_2,
    borderTopLeftRadius: 16,
    borderTopRightRadius: 16,
    gap: 24,
    borderRadius: 16,
    borderBottomLeftRadius: {
      xs: 0,
      md: 16,
    },
    borderBottomRightRadius: {
      xs: 0,
      md: 16,
    },
  },
  button: {
    width: {
      xs: '100%',
      md: 150,
    },
  },
  buttonsContainer: {
    flexDirection: {
      xs: 'column',
      md: 'row',
    },
    width: '100%',
    gap: 8,
    justifyContent: {
      xs: 'center',
      md: 'flex-end',
    },
    paddingLeft: 16,
    paddingRight: 16,
  },
}));
